import React, { useRef, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import {
  AntDesign,
  FontAwesome5,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";
import InputFree from "../../component/inputfree";
import Calendar from "react-calendar";
import moment from "moment";
import { Octicons } from "@expo/vector-icons";
import Datea from "../../component/inputdate";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { pickImage } from "../../action/authImage";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");
export default function creatediscount({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);

  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [day, setday] = useState(new Date());

  const changeDate = (e) => {
    setDateState(e);
  };
  const [locate1, setLo1] = useState({});
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());
  const [day1, setday1] = useState(new Date());
  const changeDate1 = (e) => {
    setDateState1(e);
  };

  useEffect(() => {
    if (route?.params?.id) {
      setbody(route?.params);
    }
  }, []);

  const placeholder = {
    label: "สถานะ",
    value: null,
    color: "#777777",
  };
  const [items, setItems] = useState([
    { label: "Active", value: "true" },
    { label: "Inactive", value: "false" },
  ]);
  const placeholder1 = {
    label: "",
    value: null,
    color: "#777777",
  };
  const [items1, setItems1] = useState([
    { label: "อาหาร", value: "Food" },
    { label: "คอมพิวเตอร์", value: "Computer" },
    { label: "ห้องพัก", value: "Room" },
    { label: "เครื่องใช้ไฟฟ้า", value: "Electric" },
  ]);
  const [state, setstate] = useState({
    gold: "",
    cal: "",
  });
  const [body, setbody] = useState({
    category_name: "",
    //ENUM(Food,Computer,Room,Electric)
    name: "",
    description: "",
    startDate: "",
    expireDate: "",
    total_code: "",
    last_code: "",
    img_cover: null,
    img_content: null,
    img_logo: null,
    condition: {},
    status: "",
  });
  console.log(body);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>
            DISCOUNT{" "}
            <Text style={styles.textfree1}>
              / <Text style={styles.textfree1}>ADD</Text>
            </Text>
          </Text>
          <View style={styles.viewtouch}>
            <TouchableOpacity
              onPress={async () => {
                if (body?.id) {
                  const res = await apiservice({
                    path: "/freepoint/deletediscount?id=" + body?.id,
                    method: "delete",
                    token: token?.accessToken,
                  });
                  delete body?.id;
                  if (res?.status == 200) {
                    const response = await apiservice({
                      path: "/freepoint/postdiscount",
                      method: "post",
                      body,
                      token: token?.accessToken,
                    });

                    if (response.status == 200) {
                      navigation.goBack();
                    }
                  }
                } else {
                  const response = await apiservice({
                    path: "/freepoint/postdiscount",
                    method: "post",
                    body,
                    token: token?.accessToken,
                  });

                  if (response.status == 200) {
                    navigation.goBack();
                  }
                }
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>บันทึก</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ยกเลิก</Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.view}>
          <View style={styles.viewin}>
            <InputFree
              name="ชื่อรายการ"
              placeholder="กรอกชื่อรายการ"
              value={body?.name}
              onChangeText={(text) => {
                setbody({ ...body, name: text });
              }}
            />
            <Text style={styles.textname}>รายละเอียด</Text>
            <TextInput
              multiline
              value={body?.description}
              style={styles.textinput}
              placeholder="กรอกรายละเอียดเกี่ยวกับรายการนี้"
              onChangeText={(text) => {
                setbody({ ...body, description: text });
              }}
            />
            <InputFree
              name="จำนวนสิทธ์"
              placeholder="กรอกจำนวนเป็นตัวเลข"
              value={body?.total_code}
              onChangeText={(text) => {
                setbody({ ...body, total_code: text, last_code: text });
              }}
            />
            <Text style={[styles.textname, { marginBottom: 5 }]}>หมวดหมู่</Text>
            <View style={{ flexDirection: "row" }}>
              <RNPickerSelect
                placeholder={placeholder1}
                onValueChange={(text) =>
                  setbody({ ...body, category_name: text })
                }
                value={body?.category_name}
                style={{
                  inputWeb: {
                    width: width * 0.395,
                    height: 30,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    paddingLeft: 10,
                    borderRadius: 5,
                    color: "#777777",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                  },
                }}
                items={items1}
              />
              <Octicons
                name="triangle-down"
                size={20}
                color="#FCC81D"
                style={{ alignSelf: "center", marginLeft: -20 }}
              />
            </View>
            <View style={styles.kob}>
              <Text style={styles.textname}>รูปหน้าปก</Text>
              <View style={styles.style}>
                {body.img_content == null ? (
                  <View style={styles.viewimg} />
                ) : (
                  <Image
                    style={{ width: 150, height: 70, alignSelf: "center" }}
                    source={{
                      uri:

                        body.img_content,
                    }}
                  />
                )}

                <View style={{ marginLeft: 20 }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        setbody({ ...body, img_content: response });
                      }}
                      style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                    >
                      <Text style={styles.textup}>Upload</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[styles.tochup, { marginLeft: 20 }]}
                    >
                      <Text style={styles.textup}>Reset</Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={styles.textRe}>
                    Required image resolution 800x400, image size 10mb.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.viewin}>
            <View
              style={[
                styles.style,
                { justifyContent: "space-between" },
                { marginRight: 5 },
              ]}
            >
              <View>
                <Text style={[styles.textname, { marginBottom: 5 }]}>
                  สถานะ
                </Text>
                <RNPickerSelect
                  placeholder={placeholder}
                  value={body?.status}
                  onValueChange={(text) => setbody({ ...body, status: text })}
                  style={{
                    inputWeb: {
                      width: width * 0.18,
                      height: 30,
                      borderWidth: 1,
                      borderColor: "#ccc",
                      paddingLeft: 10,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    },
                  }}
                  items={items}
                />
              </View>
              <View>
                <Text style={[styles.textname, { marginBottom: 5 }]}>
                  แสดงผลวันที่
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    style={{
                      width: width * 0.18,
                      height: 30,
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderColor: "#D9D9D9",
                      paddingLeft: 25,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    }}
                    type={true}
                    Locate={locate}
                    setLo={setLo}
                    setHandelCalendar={setHandelCalendar}
                    value={moment(body?.startDate).format("DD/MM/YYYY")}
                    onChangeText={(text) => {
                      setbody({ ...body, startDate: text });
                    }}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      setHandelCalendar((val) => !val);
                    }}
                    style={styles.botton1}
                  >
                    <FontAwesome5
                      name="calendar-alt"
                      size={18}
                      color="#AFAFAF"
                    />
                  </TouchableOpacity>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    style={{
                      width: width * 0.18,
                      height: 30,
                      backgroundColor: "#fff",
                      borderWidth: 1,
                      borderColor: "#D9D9D9",
                      paddingLeft: 25,
                      borderRadius: 5,
                      color: "#777777",
                      fontFamily: "Prompt-Regular",
                      alignSelf: "center",
                    }}
                    type={true}
                    Locate={locate1}
                    setLo={setLo1}
                    setHandelCalendar={setHandelCalendar1}
                    value={moment(body?.expireDate).format("DD/MM/YYYY")}
                    onChangeText={(text) => {
                      setbody({ ...body, expireDate: text });
                    }}
                  />
                  <TouchableOpacity
                    onPress={() => {
                      setHandelCalendar1((val) => !val);
                    }}
                    style={styles.botton1}
                  >
                    <FontAwesome5
                      name="calendar-alt"
                      size={18}
                      color="#AFAFAF"
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
            <View style={styles.kob}>
              <Text style={styles.textname}>รูปหน้าใน</Text>
              <View style={styles.style}>
                {body.img_cover == null ? (
                  <View style={styles.viewimg} />
                ) : (
                  <Image
                    style={{ width: 150, height: 70, alignSelf: "center" }}
                    source={{
                      uri:

                        body.img_cover,
                    }}
                  />
                )}
                <View style={{ marginLeft: 20 }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        setbody({ ...body, img_cover: response });
                      }}
                      style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                    >
                      <Text style={styles.textup}>Upload</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[styles.tochup, { marginLeft: 20 }]}
                    >
                      <Text style={styles.textup}>Reset</Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={styles.textRe}>
                    Required image resolution 800x400, image size 10mb.
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.koblogo}>
              <View style={styles.style}>
                {body.img_logo == null ? (
                  <View style={styles.viewimglogo} />
                ) : (
                  <Image
                    style={{ width: 70, height: 70, alignSelf: "center" }}
                    source={{
                      uri:

                        body.img_logo,
                    }}
                  />
                )}
                <View style={{ marginLeft: 20 }}>
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        setbody({ ...body, img_logo: response });
                      }}
                      style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                    >
                      <Text style={styles.textup}>Upload</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[styles.tochup, { marginLeft: 20 }]}
                    >
                      <Text style={styles.textup}>Reset</Text>
                    </TouchableOpacity>
                    <Text style={[styles.textname, { marginLeft: 80 }]}>
                      รูป logo
                    </Text>
                  </View>
                  <Text style={styles.textRe}>
                    Required image resolution 90x90, image size 10mb.
                  </Text>
                </View>
              </View>
            </View>
            <Text style={styles.textname}>เงื่อนไขในการแลกสิทธ์</Text>
            <View style={styles.viewmain}>
              <View style={styles.mainin}>
                <Image
                  style={{
                    width: 28,
                    height: 32,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/Icon awesome-running.png")}
                />
                <TextInput
                  style={styles.inputimni}
                  value={body?.condition?.cal}
                  placeholder="กรอกจำนวนเป็นตัวเลข"
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      condition: { ...body.condition, cal: text },
                    });
                  }}
                />
              </View>
              <View style={styles.mainin}>
                <Image
                  style={{
                    width: 25,
                    height: 25,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/coin.png")}
                />
                <TextInput
                  value={body?.condition?.gold}
                  style={styles.inputimni}
                  placeholder="กรอกจำนวนเป็นตัวเลข"
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      condition: { ...body.condition, gold: text },
                    });
                  }}
                />
              </View>
            </View>
          </View>
        </View>
      </View>
      {handelCalendar && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            top: height * 0.32,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onChange={changeDate}
              onChangeText={(text) => {
                setbody({ ...body, startDate: text });
              }}
              onClickDay={(e) => {
                setday(e);
                setbody({ ...body, startDate: e });
                setTimeout(() => {
                  setHandelCalendar((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
      {handelCalendar1 && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",
            zIndex: 99,
            top: height * 0.35,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState1}
              onChange={changeDate1}
              onChangeText={(text) => {
                setbody({ ...body, expireDate: text });
              }}
              onClickDay={(a) => {
                setday1(a);
                setbody({ ...body, expireDate: a });
                setTimeout(() => {
                  setHandelCalendar1((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textadd1: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "space-between",
  },
  view: {
    width: width * 0.83,
    height: 530,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 10,
    backgroundColor: "#ffffff",
  },
  koblogo: {
    width: width * 0.395,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob: {
    width: width * 0.395,
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 151,
    height: 71,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },

  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.19,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.395,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.25,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
  },
  textinput: {
    width: width * 0.395,
    height: 70,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewmain: {
    width: width * 0.395,
    height: 75,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingHorizontal: 10,
    borderRadius: 5,
    marginBottom: 10,
    marginTop: 10,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  mainin: {
    width: width * 0.18,
    alignSelf: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  botton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
  },
  inputimni: {
    width: width * 0.14,
    height: 38,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  botton1: {
    alignSelf: "center",
    marginLeft: -25,
  },
});
